// src/pages/Accounting/Reconcile/History/historyMockData.ts

import type { ReconciliationHistoryEntry } from "./historyTypes";

/**
 * 12 months of mock reconciliation history across the operating accounts.
 * Ordered newest first so the table shows the most recent period at the top
 * without extra sorting in the component.
 */
export const mockHistoryEntries: ReconciliationHistoryEntry[] = [
  // RBC Chequing — monthly for the last 6 months
  {
    id: "hist_01",
    accountId: "acct_rbc_chequing",
    periodStart: "2026-09-01",
    periodEnd: "2026-09-30",
    statementEndingDate: "2026-09-30",
    reconciledOn: "2026-10-01",
    endingBalance: 10214.80,
    changes: 0,
    autoAdjustment: null,
    statementAttached: true,
    statementUrl: "/mock/statements/rbc-chequing-sep-2026.pdf",
    reconciledBy: "Claire Kemanzi",
  },
  {
    id: "hist_02",
    accountId: "acct_rbc_chequing",
    periodStart: "2026-08-01",
    periodEnd: "2026-08-31",
    statementEndingDate: "2026-08-31",
    reconciledOn: "2026-09-02",
    endingBalance: 8912.47,
    changes: 1,
    autoAdjustment: 12.40,
    statementAttached: true,
    statementUrl: "/mock/statements/rbc-chequing-aug-2026.pdf",
    reconciledBy: "Claire Kemanzi",
  },
  {
    id: "hist_03",
    accountId: "acct_rbc_chequing",
    periodStart: "2026-07-01",
    periodEnd: "2026-07-31",
    statementEndingDate: "2026-07-31",
    reconciledOn: "2026-08-03",
    endingBalance: 7445.19,
    changes: 0,
    autoAdjustment: null,
    statementAttached: true,
    statementUrl: "/mock/statements/rbc-chequing-jul-2026.pdf",
    reconciledBy: "Claire Kemanzi",
  },
  {
    id: "hist_04",
    accountId: "acct_rbc_chequing",
    periodStart: "2026-06-01",
    periodEnd: "2026-06-30",
    statementEndingDate: "2026-06-30",
    reconciledOn: "2026-07-04",
    endingBalance: 6102.33,
    changes: 2,
    autoAdjustment: null,
    statementAttached: true,
    statementUrl: "/mock/statements/rbc-chequing-jun-2026.pdf",
    reconciledBy: "Claire Kemanzi",
  },
  {
    id: "hist_05",
    accountId: "acct_rbc_chequing",
    periodStart: "2026-05-01",
    periodEnd: "2026-05-31",
    statementEndingDate: "2026-05-31",
    reconciledOn: "2026-06-02",
    endingBalance: 5820.11,
    changes: 0,
    autoAdjustment: null,
    statementAttached: false,
    reconciledBy: "Claire Kemanzi",
  },
  {
    id: "hist_06",
    accountId: "acct_rbc_chequing",
    periodStart: "2026-04-01",
    periodEnd: "2026-04-30",
    statementEndingDate: "2026-04-30",
    reconciledOn: "2026-05-04",
    endingBalance: 4418.22,
    changes: 1,
    autoAdjustment: 3.95,
    statementAttached: true,
    statementUrl: "/mock/statements/rbc-chequing-apr-2026.pdf",
    reconciledBy: "Claire Kemanzi",
  },

  // RBC Savings — quarterly for the last 3 quarters
  {
    id: "hist_07",
    accountId: "acct_rbc_savings",
    periodStart: "2026-07-01",
    periodEnd: "2026-09-30",
    statementEndingDate: "2026-09-30",
    reconciledOn: "2026-10-02",
    endingBalance: 42890.12,
    changes: 0,
    autoAdjustment: null,
    statementAttached: true,
    statementUrl: "/mock/statements/rbc-savings-q3-2026.pdf",
    reconciledBy: "Claire Kemanzi",
  },
  {
    id: "hist_08",
    accountId: "acct_rbc_savings",
    periodStart: "2026-04-01",
    periodEnd: "2026-06-30",
    statementEndingDate: "2026-06-30",
    reconciledOn: "2026-07-02",
    endingBalance: 38112.44,
    changes: 0,
    autoAdjustment: null,
    statementAttached: true,
    statementUrl: "/mock/statements/rbc-savings-q2-2026.pdf",
    reconciledBy: "Claire Kemanzi",
  },
  {
    id: "hist_09",
    accountId: "acct_rbc_savings",
    periodStart: "2026-01-01",
    periodEnd: "2026-03-31",
    statementEndingDate: "2026-03-31",
    reconciledOn: "2026-04-04",
    endingBalance: 34218.90,
    changes: 1,
    autoAdjustment: null,
    statementAttached: true,
    statementUrl: "/mock/statements/rbc-savings-q1-2026.pdf",
    reconciledBy: "Claire Kemanzi",
  },

  // RBC Visa Business — bimonthly for the last 4 periods
  {
    id: "hist_10",
    accountId: "acct_rbc_visa",
    periodStart: "2026-09-01",
    periodEnd: "2026-09-25",
    statementEndingDate: "2026-09-25",
    reconciledOn: "2026-09-28",
    endingBalance: 1847.33,
    changes: 2,
    autoAdjustment: null,
    statementAttached: true,
    statementUrl: "/mock/statements/rbc-visa-sep-2026.pdf",
    reconciledBy: "Claire Kemanzi",
  },
  {
    id: "hist_11",
    accountId: "acct_rbc_visa",
    periodStart: "2026-08-01",
    periodEnd: "2026-08-25",
    statementEndingDate: "2026-08-25",
    reconciledOn: "2026-08-30",
    endingBalance: 2144.08,
    changes: 0,
    autoAdjustment: null,
    statementAttached: true,
    statementUrl: "/mock/statements/rbc-visa-aug-2026.pdf",
    reconciledBy: "Claire Kemanzi",
  },
  {
    id: "hist_12",
    accountId: "acct_rbc_visa",
    periodStart: "2026-07-01",
    periodEnd: "2026-07-25",
    statementEndingDate: "2026-07-25",
    reconciledOn: "2026-07-29",
    endingBalance: 1572.90,
    changes: 1,
    autoAdjustment: 0.75,
    statementAttached: true,
    statementUrl: "/mock/statements/rbc-visa-jul-2026.pdf",
    reconciledBy: "Claire Kemanzi",
  },

  // TD USD — never reconciled, so no entries here
];